import { Grid, IconButton, InputBase, Typography } from "@mui/material"
import React from "react"
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid"
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { useForm } from "react-hook-form";
import WSDateField from "../../Components/DateField/WSDateField";
import { AllOrderSummary } from "./AllOrderSummary";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { Running } from "./Running";
import { Settled } from "./Settled";
import { Voided } from "./Voided";
export const OrderSummary:React.FC<any>=React.memo((props)=>{
   const {
     register,
     control,
     
   }= useForm()

   const tabs = [
    { label: "All", content:<AllOrderSummary/>},
    { label: "Running", content: <Running/> },
    { label: "Settled", content: <Settled/>},
    { label: "Voided", content: <Voided/> },
    
  ];
    return(
<Grid sx={{padding:"3rem"}}>
  <form>
    <Typography variant="h5">
      Order Summary
    </Typography>
    <Grid container spacing={2} sx={{mt:3}}>
      <Grid item xs={12} sm={2}>
      <WSDateField
              id="date"
              name="date"
              label=""
              dateFormat="D/MM/YYYY"
              control={control}
              defaultValue={null}
              rules={{ required: false }}
              labelType="Normal"
            />
      </Grid>
      <Grid item xs={12} sm={6}>
      <WSTextField
              label={"Search"}
              {...register("search")}
              id="search"
              name="search"
              control={control}
              rules={{ required: false }}
            />
                  </Grid>

            <Grid item xs={12} sm={2}>
              <WSIcons.SearchIcon style={{ color: 'black', position:'relative' }} />
            </Grid>
      <Grid item xs={12} >
      <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />

      </Grid>
    </Grid>
  </form>
</Grid>
    )
})